import axios from "../../../axios"
import { parseObjectParamsToString } from '@/utils'

export default {
  fetch(searchParams) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/graphql'

    return axios.post('', {
      query: `
        query {
          tutorialVideos ${parseObjectParamsToString(searchParams)} {
            id,
            name,
            route,
            video_url
          }
        }
      `
    })
  }
}
